function initCarousels() {
  document.querySelectorAll('.carousel .swiper').forEach(function(swiperElement) {
    if (swiperElement.swiper) return;

    var carousel = swiperElement.closest('.carousel');

    new Swiper(swiperElement, {
      loop: true,
      slidesPerView: 'auto',
      speed: 9000,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
        reverseDirection: carousel && carousel.dataset.carouselDirection === 'right'
      }
    });
  });
}

window.addEventListener('load', initCarousels);

document.addEventListener('shopify:section:load', function(event) {
  initCarousels(event.target);
});

document.addEventListener('click', function(event) {
  var button = event.target.closest('[data-carousel-play]');
  if (!button) return;

  var media = button.closest('.carousel__media');
  var video = media ? media.querySelector('video') : null;
  if (!video) return;

  event.preventDefault();

  document.querySelectorAll('.carousel__media video').forEach(function(otherVideo) {
    var otherMedia = otherVideo.closest('.carousel__media');
    var otherButton = otherMedia ? otherMedia.querySelector('[data-carousel-play]') : null;

    if (otherVideo !== video) {
      otherVideo.pause();
      otherVideo.currentTime = 0;
    }

    if (otherButton) {
      otherButton.hidden = false;
    }
  });

  var playPromise = video.play();
  button.hidden = true;

  if (playPromise) {
    playPromise.catch(function() {
      button.hidden = false;
    });
  }
});
